import React from "react";
import "./style.scss";

const Label = ({ children, labelTitle, forId, classname }) => {
  return (
    <label className={`label ${classname}`} htmlFor={forId}>
      {children}
      {labelTitle}
    </label>
  );
};

export default Label;
